import {Pipe} from "@angular/core";
import {KompaktdarstellungPipe} from "../kompakt-darstellung.pipe";
import {FormatConfigService} from "../../../core/services/format-config.service";
import {PlatformLocation} from "@angular/common";
import {ComponentLocationStrategy} from "../../services/location-strategy/component-location-strategy";
import {DecimalHochkommaPipe} from "../../pipes/simple/decimalHochkomma.pipe";
import {GebaeudeListEntry} from "../../../core/av-api";
import {GebaeudeArtStringPipe} from "../../pipes/simple/gebaeude-art-string.pipe";

@Pipe({
  name: 'kompaktGebaeude'
})
export class KompaktGebaeudePipe extends KompaktdarstellungPipe<GebaeudeListEntry> {

  constructor(protected formatConfigService: FormatConfigService, protected location: PlatformLocation,
              protected kompaktLocation: ComponentLocationStrategy, private hochkommaPipe: DecimalHochkommaPipe, private gebaeudeArtStringPipe: GebaeudeArtStringPipe) {
    super(formatConfigService, 'GEBAEUDE', location, kompaktLocation);
  }

  transform(gebaeude: GebaeudeListEntry): string {
    if (!gebaeude) {
      return '';
    }
    if (this.formatElement === 'GEBAEUDE_TYP00') {
      return [this.getArtZusatzSummary(gebaeude), this.getFlaeche(gebaeude.flaeche), this.getVersicherungsnummer(gebaeude)].filter(val => val).join(', ');
    }
    if (this.formatElement === 'GEBAEUDE_TYP01') {
      return [this.getArtZusatzSummary(gebaeude), this.getGrundstueckZuGebFlaeche(gebaeude.flaeche, gebaeude.grundstueckZuGebaeudeFlaeche),
        this.getGesamtFlaeche(gebaeude.flaeche, gebaeude.grundstueckZuGebaeudeFlaeche), this.getVersicherungsnummer(gebaeude)].filter(val => val).join(', ');
    }
    if (this.formatElement === 'GEBAEUDE_TYP02') {
      return [this.getArtZusatzSummary(gebaeude), this.getVersicherungsnummer(gebaeude)].filter(val => val).join(', ');
    }
    if (this.formatElement === 'GEBAEUDE_TYP03') {
      return this.getArtZusatz(gebaeude);
    }
    return this.getArtZusatz(gebaeude);
  }

  private getVersicherungsnummer(gebaeude: GebaeudeListEntry): string {
    if (gebaeude.versicherungsNummer) {
      return 'Assek. Nr. ' + gebaeude.versicherungsNummer;
    }
    return '';
  }

  private getGesamtFlaeche(flaeche: number, grundstZuGebFlaeche: number): string {
    if (flaeche && grundstZuGebFlaeche && flaeche !== grundstZuGebFlaeche) {
      return 'Gesamtfläche ' + this.getFlaeche(flaeche);
    }
    if (flaeche) {
      return this.getFlaeche(flaeche);
    }
    return '';
  }

  private getFlaeche(flaeche: number): string {
    if (flaeche) {
      return this.hochkommaPipe.transform(flaeche) + ' m2';
    }
    return '';
  }

  private getGrundstueckZuGebFlaeche(flaeche: number, grundstZuGebFlaeche: number): string {
    if (flaeche && grundstZuGebFlaeche && flaeche !== grundstZuGebFlaeche) {
      return this.hochkommaPipe.transform(grundstZuGebFlaeche) + ' m2';
    }
    return '';
  }

  private getArtZusatzSummary(gebaeude: GebaeudeListEntry) {
    return [this.getArtZusatz(gebaeude), this.getSummary(gebaeude)].filter(val => val).join(' ');
  }

  private getArtZusatz(gebaeude: GebaeudeListEntry): string {
    return this.gebaeudeArtStringPipe.transform(gebaeude.gebaeudeArten);
  }

  private getSummary(gebaeude: GebaeudeListEntry): string {
    let summary = [gebaeude.istUnterirdisch ? 'unterirdisch' : '', gebaeude.istProjektiert ? 'projektiert' : '', gebaeude.istEinzelobjekt ? 'Einzelobjekt' : ''].filter(val => val).join(', ');
    if (summary.length > 0) {
      summary = '(' + summary + ')';
    }
    return summary;
  }
}
